export default __webpack_public_path__ + "static/media/percentage.8ecf0d75.svg";